export const AllStrategizeRoutes = {
  index: "/strategize",
};
